import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '../../';
import parseStatusCode from '../../errors/parseStatusCode';
import type { Injections } from '../../services/injections';
import type { Schedule } from '../../services/FP_FulfillmentContextService/types';
import type { ApplicationErrorOptions } from '../../../types';

export interface SchedulesModel {
  schedulesMap: Record<string, Schedule>;
  setSchedules: Action<SchedulesModel, Schedule[]>;
  setSchedule: Action<SchedulesModel, Schedule>;
  fetchSchedulesLoading: boolean;
  setFetchSchedulesLoading: Action<SchedulesModel, boolean>;
  fetchSchedules: Thunk<SchedulesModel, void, Injections, StoreModel, Promise<void>>;
  fetchSchedulesFailure: Action<SchedulesModel, ApplicationErrorOptions>;
}

export const schedulesModel: SchedulesModel = {
  schedulesMap: {},
  setSchedules: action((state, schedules) => {
    const schedulesMap = schedules.reduce<Record<string, Schedule>>((acc, curr) => {
      acc[curr.scheduleId] = curr;
      return acc;
    }, {});
    state.schedulesMap = schedulesMap;
  }),
  setSchedule: action((state, schedule) => {
    state.schedulesMap[schedule.scheduleId] = schedule;
  }),
  fetchSchedulesLoading: false,
  setFetchSchedulesLoading: action((state, isLoading) => {
    state.fetchSchedulesLoading = isLoading;
  }),
  fetchSchedules: thunk(async (actions, payload, { injections, getState }) => {
    try {
      actions.setFetchSchedulesLoading(true);
      const { fulfillmentContextService } = injections;
      const response = await fulfillmentContextService.fetchSchedules();
      actions.setSchedules(response);
      actions.setFetchSchedulesLoading(false);
      return response;
    } catch (error) {
      actions.fetchSchedulesFailure({
        error,
        httpCode: parseStatusCode(error),
        asNotification: false,
        message: error.message || 'An error occurred, unable to fetch asset details',
      });
      return error;
    }
  }),
  fetchSchedulesFailure: action((state, error) => {
    console.error(error);
  }),
};

export default schedulesModel;
